export const REMOVE_FOOTER_INVISIBILITY = 'REMOVE_FOOTER_INVISIBILITY';
